export const dateFormatConfig = {
  'DD-MM-YYYY': {
    dateSeperator: '-',
    dateFormatInput: 'DD-MM-YYYY' /* 15-08-2022 */,
    dateFormatShortNoYearNoWeekDay: 'D MMM' /* 15 Aug */,
    dateFormatShortNoYearWithWeekDay: 'dd D MMM' /* Mo 15 Aug */,
    dateFormatShortWithYearWithWeekDay: 'dd D MMM YYYY' /* Mo 15 Aug 2022 */,
    dateFormatShortWithYearNoWeekDay: 'D MMM YYYY' /* 15 Aug 2022 */
  },
  'MM/DD/YYYY': {
    dateSeperator: '/',
    dateFormatInput: 'MM/DD/YYYY' /* 08/15/2022 */,
    dateFormatShortNoYearNoWeekDay: 'MMM D' /* Aug 15 */,
    dateFormatShortNoYearWithWeekDay: 'dd MMM D' /* Mo Aug 15 */,
    dateFormatShortWithYearWithWeekDay: 'dd MMM D, YYYY' /* Mo Aug 15, 2022 */,
    dateFormatShortWithYearNoWeekDay: 'MMM D, YYYY' /* Aug 15, 2022 */
  },
  'YYYY-MM-DD': {
    dateSeperator: '-',
    dateFormatInput: 'YYYY-MM-DD' /* 2022-08-15 */,
    dateFormatShortNoYearNoWeekDay: 'D MMM' /* 15 Aug */,
    dateFormatShortNoYearWithWeekDay: 'dd D MMM' /* Mo 15 Aug */,
    dateFormatShortWithYearWithWeekDay: 'dd D MMM YYYY' /* Mo 15 Aug 2022 */,
    dateFormatShortWithYearNoWeekDay: 'D MMM YYYY' /* 15 Aug 2022 */
  }
};

export const dateFormatOptions = ['DD-MM-YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'];
export const defaultDateFormat = 'DD-MM-YYYY';
